import { FC } from "react";
import { TeamContext } from "../../../types/common";
import icon1 from '../../../assets/timeline/icon1.png';
import icon2 from '../../../assets/timeline/icon2.png';
import icon3 from '../../../assets/timeline/icon3.png';
import icon4 from '../../../assets/timeline/icon4.png';
import icon5 from '../../../assets/timeline/icon5.png';
import { TeamTimeline } from "../../../components/layout/TeamTimeline";

interface TimelineProps {
    team: TeamContext;
}

export const Timeline: FC<TimelineProps> = ({
    team
}) => {
    if (team !== TeamContext.RODINA) {
        return null;
    }

    return (
        <TeamTimeline
            items={[
                {
                    year: 2015,
                    title: 'Основание',
                    icon: <img src={icon1} className="w-full" />,
                    link: "/club/?club2015#club2015",
                },
                {
                    year: 2016,
                    title: 'КФК',
                    icon: <img src={icon2} className="w-full"  />,
                    gapClass: "w-20",
                    link: "/club/?club2016#club2016",
                },
                {
                    year: 2019,
                    title: 'ПФЛ',
                    icon: <img src={icon3} className="w-full"  />,
                    gapClass: "w-20",
                    link: "/club/?club2019#club2019",
                },
                {
                    year: 2021,
                    title: 'Стадион',
                    icon: <img src={icon4} className="w-full"  />,
                    link: "/club/?club2021#club2021",
                },
                {
                    year: 2022,
                    title: 'ФНЛ',
                    icon: <img src={icon5} className="w-full"  />,
                    gapClass: "w-20",
                    link: "/club/?club2022#club2022",
                }
            ]}
        />
    );
}